import { hardNavigation } from "../../utils/hard-navigation.util";
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VngSelectOption } from "@vengreso/angular-components";

import { find, forEach, remove } from "lodash";
import { Observable, Subscription } from "rxjs";
import * as XLSX from "xlsx";

import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import { EventService } from "src/app/core/core-services/services/event.service";
import { NotificationService } from "src/app/core/core-services/services/notification.service";

import { ShortcutService } from "src/app/core/core-services/services/shortcut.service";
import { StripeService } from "src/app/core/core-services/services/stripe.service";
import { TinyMceConfigService } from "src/app/core/core-services/services/tiny-mce-config.service";
import { ExtensionService } from "./../../core/core-services/services/extension.service";
import { ScriptService } from "./../../core/core-services/services/script.service";
import { ExtensionSettingsComponent } from "./extension-settings/extension-settings.component";
import { CanComponentDeactivate } from "src/app/vengreso/user-persona-add/can-deactivate-form.guard";

import { ImportDialogComponent } from "src/app/core/core-services/import-dialog/import-dialog.component";
import { ImportPreviewDialogComponent } from "src/app/core/core-services/import-preview-dialog/import-preview-dialog.component";
import { LoadingDialogComponent } from "src/app/core/core-services/loading-dialog/loading-dialog.component";
import { WarningDialogComponent } from "src/app/core/core-services/warning-dialog/warning-dialog.component";
import { CategoryDependencyComponent } from "../shortcuts/add-shortcut-category/category-dependency/category-dependency.component";
import { CategoryRenameComponent } from "../shortcuts/add-shortcut-category/category-rename/category-rename.component";
import { EditPlanComponent } from "./edit-plan/edit-plan.component";
import { PausedPlanComponent } from "./paused-plan/paused-plan.component";

import { ChartConfiguration, ChartType } from "chart.js";
import { BaseChartDirective } from "ng2-charts";
import { ApplicationConstants } from "src/app/core/core-services/constants/application.constants";
import { getPlanId, getRewards } from "src/app/core/core-services/constants/plans.constants";
import { MetaService } from "src/app/core/core-services/services/meta.service";
import { ChartFilterKey, DateType, StatisticsService } from "src/app/core/core-services/services/statistics.service";
import { PlanFeatures, PlanStatus, SubscriptionPlanType } from "src/app/core/models/stripe.models";
import { isFreemiumTier, isGrowthOrHigherTier, isStarterTier } from "src/app/utils/plan-tier.utils";
import {
  selectPlanFeatures,
  selectPlanData,
  selectPlanDisplayName,
  selectPlanType,
  selectIsFreemium,
  selectIsStarter,
  selectIsGrowthOrHigher
} from "src/app/core/store/plan/plan.selectors";
import { DowngradedComponent } from "./downgraded/downgraded.component";
import {
  CTA_COMPARE_PLAN_ID,
  CTA_DOWNGRADE_TO_FREEMIUM_ID,
  CTA_EDIT_PLAN_GROWTH_ID,
  CTA_EDIT_PLAN_GROWTH_URL,
  CTA_EDIT_PLAN_ID,
  CTA_EDIT_PLAN_URL,
  CTA_GROWTH_DOWNGRADE_TO_FREEMIUM_ID,
  CTA_GROWTH_DOWNGRADE_TO_STARTER_ID,
  CTA_GROWTH_PAUSE_PLAN_ID,
  CTA_PAUSE_PLAN_ID,
  CTA_UPGRADE_PLAN_ID,
  CTA_UPGRADE_PLAN_URL,
  SUBSCRIPTION_EDIT_GROWTH,
  SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_FREEMIUM,
  SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_STARTER,
  SUBSCRIPTION_EDIT_GROWTH_PAUSED,
  SUBSCRIPTION_EDIT_STARTER,
  SUBSCRIPTION_EDIT_STARTER_DOWNGRADE_FREEMIUM,
  SUBSCRIPTION_EDIT_STARTER_PAUSED,
  SUBSCRIPTION_TAB,
  SUBSCRIPTION_TAB_PARAMS,
} from "./settings.config";
import { Store } from "@ngrx/store";
import { PlanState } from "src/app/core/store/plan/plan.reducer";
import {
  ShortcutCategoryService,
  SHORTCUT_CATEGORIES,
} from "src/app/core/core-services/services/shortcut-category.service";
import { CONTENT_VIEW_LOADER } from "src/app/core";
import { NotifyService } from "src/app/core/menu/not.service";
import moment from "moment";
import { AuthService } from "src/app/core/core-services/services/auth.service";
import { SsoRedirectService } from "src/app/core/core-services/services/sso-redirect.service";
import { SharedDataService } from "src/app/core/core-services/services/shared-data.service";
import { DynamicStorage } from "src/app/core/core-services/decorators/dynamic-storage";
import { ApiResponse } from "src/app/core/models/api.model";
import { RoleplayAddOn, RoleplayApiResult, RoleplayUserInfo, isPaidRoleplayAddOn } from "src/app/core/models/roleplay.models";
import {
  ImportedFlyCut,
  ImportFailure,
  ImportShortcutApiService,
} from "src/app/core/core-services/services/import-shortcut-api/import-shortcut-api.service";
declare let hbspt: any;

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    standalone: false
})
export class SettingsComponent implements AfterViewInit, OnInit, OnDestroy, CanComponentDeactivate {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  @ViewChild("extensionSettings") extensionSettings: ExtensionSettingsComponent;

  planId: string;
  list: { shortcut_timeout: number; blocked_domains: any[] };
  wphOverrideUser: boolean = false;
  isFlycutsImported: boolean = false;
  records: any[] = [];
  jsonPlaceHolder: string;
  jsonPlaceHolderCopy: string;
  @DynamicStorage(SHORTCUT_CATEGORIES) shortcutCategoryList: any[];
  flattedCategories: any[];
  activeTabIndex: number;
  subscriptions = new Subscription();
  displayedColumns: string[] = ["name", "shortcut_count", "action"];
  editorApiKey: string;
  editorConfig: any;
  panelOpenState = {};
  browser_type;
  subPlans = SubscriptionPlanType;
  currentPlan: SubscriptionPlanType;
  currentPlan$ = this.store.select(selectPlanData);
  planDisplayName$ = this.store.select(selectPlanDisplayName);
  planType$ = this.store.select(selectPlanType);
  isFreemium$ = this.store.select(selectIsFreemium);
  isStarter$ = this.store.select(selectIsStarter);
  isGrowthOrHigher$ = this.store.select(selectIsGrowthOrHigher);
  renewalDays = -1;
  /** Paid RolePlay add-on of an individual user, or null — see loadRoleplaySubscription. */
  roleplayAddOn: RoleplayAddOn | null = null;
  ends_at;
  planStatus = PlanStatus;
  currentPlanStatus: string = PlanStatus.Active;
  importRestrictionError = false;
  /** Selected rows that currently collide. Kept separate from the import payload. */
  duplicateImportRows: any[] = [];
  /** Rows rejected by the library's unique-code constraint. */
  libraryConflictRows: any[] = [];
  importSubmitting = false;
  private readonly importRowIds = new WeakMap<object, string>();
  private nextImportRowId = 0;
  private editingImportRowIds = new Set<string>();
  currentFeatures: PlanFeatures;
  currentPlanId: string;

  // ! TODO To transfer to select a plan component, then change this value to whatever plan is selected

  tabIndex: number = 0;
  dateFilterValue: number = 7;
  chartFilterKey: ChartFilterKey = "time_saved";

  wagePerHour;
  wordsPerMinute;
  statistics: any;
  public lineChartData: ChartConfiguration["data"] = null;

  public lineChartOptions: ChartConfiguration["options"] = {
    elements: {
      line: {
        tension: 0.5,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      y: {
        position: "left",
        min: 0,
      },
      x: {
        min: 0,
      },
      // y1: {
      //   position: "right",
      //   grid: {
      //     color: "#FDFEFE",
      //   },
      //   ticks: {
      //     // color: "red",
      //   },
      // },
    },
    maintainAspectRatio: false,
  };

  public lineChartType: ChartType = "line";

  editWPM: boolean;
  editWPH: boolean;

  dateRanges = [
    // { text: "Past 24 hours", id: 1, differenceFromNow: 24, dateType: "hour" },
    // { text: "Last 7 days", id: 2, differenceFromNow: 7, dateType: "day" },
    { text: "Last month", id: 3, differenceFromNow: 1, dateType: "month" },
    { text: "Last 3 months", id: 4, differenceFromNow: 3, dateType: "month" },
    { text: "Last 6 months", id: 5, differenceFromNow: 6, dateType: "month" },
    { text: "Last 9 months", id: 6, differenceFromNow: 9, dateType: "month" },
    { text: "Last 12 months", id: 7, differenceFromNow: 12, dateType: "month" },
    { text: "Last 24 months", id: 8, differenceFromNow: 24, dateType: "month" },
    { text: "Last 36 months", id: 9, differenceFromNow: 36, dateType: "month" },
    { text: "All Times", id: 10, differenceFromNow: -1, dateType: "month" },
  ];

  // C3-5 (R5): mat-select options are children in Material; vng-select wants
  // data. Flatten the existing {text,value}/{text,id} arrays into
  // VngSelectOption[] once per read instead of restructuring the source arrays.
  get chartFilterVngOptions(): VngSelectOption[] {
    return this.statisticsService.chartFilterOptions.map((o) => ({ value: o.value, label: o.text }));
  }

  get dateRangeVngOptions(): VngSelectOption[] {
    return this.dateRanges.map((r) => ({ value: r.id, label: r.text }));
  }

  constructor(
    public dialog: DialogService,
    private readonly route: ActivatedRoute,
    private readonly _router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly dataService: DataService,
    private readonly eventService: EventService,
    private readonly notification: NotificationService,
    private readonly shortcutService: ShortcutService,
    private readonly extensionService: ExtensionService,
    private readonly stripeService: StripeService,
    private readonly renderer: Renderer2,
    private readonly scriptService: ScriptService,
    public statisticsService: StatisticsService,
    private readonly metaService: MetaService,
    private readonly store: Store<PlanState>,
    private readonly shortcutCategoryService: ShortcutCategoryService,
    public notifyService: NotifyService,
    private readonly authService: AuthService,
    private readonly ssoRedirect: SsoRedirectService,
    private readonly sharedData: SharedDataService,
    private readonly tinyMceConfigService: TinyMceConfigService,
    private readonly importShortcutApi: ImportShortcutApiService
  ) {
    this.browser_type = this.sharedData.getAttribute("browser_type");
    // Initialize currentPlan to Freemium, will be updated by NgRx subscription
    this.currentPlan = SubscriptionPlanType.Freemium;

    this.metaService.addMetaTag(
      "FlyMSG Settings Page",
      "You can manage your entire account here from the FlyMSG Settings page including, learn about your stats, import from other providers and much more."
    );
  }

  async ngOnInit() {
    // Subscribe to plan type for currentPlan enum value
    this.planType$.subscribe((planType: SubscriptionPlanType) => {
      this.currentPlan = planType;
    });

    // Subscribe to plan data for additional fields (ends_at, plan_status)
    this.currentPlan$.subscribe((planInfo: any) => {
      if (planInfo) {
        this.ends_at = planInfo?.ends_at?.split("T")[0] ?? planInfo?.ends_at;
        this.currentPlanStatus = planInfo?.plan_status ?? PlanStatus.Active;
      }
    });

    this.sharedData.storage.observe(SHORTCUT_CATEGORIES).subscribe((value) => {
      if (Array.isArray(value)) this.shortcutCategoryList = value;
      this.flattedCategories = this.flatTheCategories(this.shortcutCategoryList);
      this.eventService.updateShortcutCategories(this.shortcutCategoryList);
    });

    this.loadRoleplaySubscription();
    this.loadData();
  }

  /**
   * Individual users can hold a RolePlay subscription separate from their
   * FlyMSG plan, billed and managed in the roleplay app. Surface a paid one
   * on the Subscription tab; company users (roleplay billing is
   * company-managed) and free/absent roleplay plans show nothing.
   */
  private loadRoleplaySubscription(): void {
    if (this.isCompanyUser) {
      return;
    }
    this.dataService
      .get({ url: "v2/role-play/user/info", isLoader: false, ignoreErrors: true })
      .subscribe({
        next: (response: ApiResponse<RoleplayApiResult<RoleplayUserInfo>>) => {
          const addOn = response?.result?.data?.add_on;
          this.roleplayAddOn = isPaidRoleplayAddOn(addOn) ? addOn : null;
        },
        error: () => {
          this.roleplayAddOn = null;
        },
      });
  }

  manageRoleplaySubscription(): void {
    this.ssoRedirect.openRolePlay("/settings/subscription");
  }

  get roleplayBillingPeriod(): string {
    return this.roleplayAddOn?.recurrency_type === "yearly" ? "year" : "month";
  }

  ngAfterViewInit(): void {
    this.planId = getPlanId();

    this.subscriptions.add(
      this.notifyService.behaviourNotifier.subscribe((notified) => {
        if (notified && notified.plan) {

          this.currentPlan =
            notified.plan === SubscriptionPlanType.SalesPro
              ? SubscriptionPlanType.Growth
              : notified.plan === SubscriptionPlanType.YearlySalesPro
                ? SubscriptionPlanType.YearlyGrowth
                : notified.plan;
          this.currentPlanStatus = notified.planStatus;

          if (notified.planStatus == PlanStatus.Trial) {
            this.ends_at = moment().add(14, "days").format("YYYY-MM-DD");
          }
        }
        this.cdr.detectChanges();
      })
    );
  }

  private loadData(settings?: any): void {
    if (settings) {
      this.list = settings;
    } else if (this.route.snapshot.data.settings && this.route.snapshot.data.settings.result) {
      this.list = this.route.snapshot.data.settings.result;
      this.wagePerHour = this.route.snapshot.data.settings.result.wage_per_hour;
      this.wordsPerMinute = this.route.snapshot.data.settings.result.words_per_minute;
      if (
        this.route.snapshot.data.settings.result.company?.override_user_wage_per_hour &&
        this.route.snapshot.data.settings.result.company?.wage_per_hour !== undefined
      ) {
        this.wphOverrideUser = true;
        this.wagePerHour = this.route.snapshot.data.settings.result.company.wage_per_hour;
      }
    }

    this.jsonPlaceHolder = this.jsonPlaceHolderCopy = JSON.stringify(
      [
        {
          title: "talk to you later",
          shortcut: "ttyl",
          html: "Talk to you later",
        },
      ],
      null,
      4
    );

    this.flattedCategories = this.flatTheCategories(this.shortcutCategoryList);
    this.eventService.updateShortcutCategories(this.shortcutCategoryList);

    this.subscriptions.add(
      this.route.queryParams.subscribe((params) => {
        if (Object.keys(params).length > 0) {
          if (params.add === "true") {
            this.activeTabIndex = 3;
            this.shortcutCategoryRename({
              shortcutCategoryList: this.shortcutCategoryList,
            });
          } else if (params.tab === "manage") {
            this.activeTabIndex = 3;
            this.shortcutCategoryService.loadShortcutCategory({
              reloadFromApi: true,
            });
          } else if (SUBSCRIPTION_TAB_PARAMS.includes(params.tab)) {
            this.activeTabIndex = 0;
            this.loadCtaScripts(params.tab);
            this.showDialog(params.tab);
          } else if (params.tab === "Profile") {
            this.activeTabIndex = 2;
          } else if (params.tab === "Persona") {
            this.activeTabIndex = 4;
          } else if (params.tab === "extension") {
            this.activeTabIndex = 5;
          } else if (params.tab === "import") {
            this.activeTabIndex = 6;
          } else if (params.tab === "statistics") {
            this.activeTabIndex = 1;
          }
        } else {
          this.activeTabIndex = 0;
          this.loadCtaScripts(params.tab);
          this.showDialog(params.tab);
        }
      })
    );

    this.subscriptions.add(
      this.eventService.getAddCategoryListener().subscribe((data) => {
        if (data) {
          this.activeTabIndex = 3;
          this.shortcutCategoryRename({
            shortcutCategoryList: this.shortcutCategoryList,
          });
        }
      })
    );

    this.currentPlanId = getPlanId();

    this.subscriptions.add(
      this.store.select(selectPlanFeatures).subscribe((features: PlanFeatures) => {
        if (features) {
          this.currentFeatures = features;
          this.updateEditorConfig();
        }
      })
    );

    this.editorApiKey = ApplicationConstants.TINYMCE_API_KEY;
    this.updateEditorConfig();
    this.getStatistic();
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  private updateEditorConfig() {
    const baseConfig = this.shortcutService.getEditorConfig();
    this.editorConfig = this.tinyMceConfigService.getPlanBasedConfig(
      this.currentFeatures,
      baseConfig,
      this,
      this.currentPlanId,
      (type, error, showTheStarter) => {
        this.dialog.openDialogComponent(
          WarningDialogComponent,
          { type, error, showTheStarter },
          "500px"
        );
      }
    );
    this.editorConfig.forced_root_block = "";
  }

  get isCompanyUser() {
    return this.authService.isCompanyEndUser;
  }

  // Start Subscription tab
  editPaymentDetails(): void {
    // TODO: Change this to go to an edit details page (to perform same steps as payment page minus the final purchase subscription command)
    this._router.navigate(["payment-method-details"]);
  }

  pausePlan(): void {
    // if (
    //   confirm(
    //     "Are you sure you want to pause your current " +
    //       this.currentPlan.toLowerCase() +
    //       " plan?"
    //   )
    // ) {
    this.stripeService.pausePlan();
    // }
  }

  resumePlan(): void {
    // if (confirm("Are you sure you want to resume your previous plan?")) {
    this.stripeService.resumePlan();
    // }
  }

  // upgradePlan(plan: SubscriptionPlanType): void {
  //   // this._router.navigate(["new-plan", plan]);
  //   this._router.navigate(["plans", plan]);
  // }
  upgradePlan(): void {
    hardNavigation.navigate(CTA_UPGRADE_PLAN_URL);
  }

  editPlan(): void {
    hardNavigation.navigate(this.isStarterPlan()
      ? CTA_EDIT_PLAN_URL
      : this.isGrowthPlan()
        ? CTA_EDIT_PLAN_GROWTH_URL
        : "");
  }

  viewBillingHistory(): void {
    // TODO: create billing history page
    this._router.navigate(["billing-history"]);
  }

  cancelAccount(): void {
    // TODO: implement cancel subscription account, for now, pausing the plan will work the same
    // if (
    //   confirm(
    //     "Are you sure you want to cancel your current " +
    //       this.currentPlan.toLowerCase() +
    //       " plan?"
    //   )
    // ) {
    return null;
    this.stripeService.pausePlan();
    // }
  }
  // End Subscription Tab

  flatTheCategories(categories: any) {
    let flatedCategories: [] = [];
    categories?.forEach((group: any) => {
      flatedCategories.push(group as never);
      if (group.sub_category_lv1) {
        for (const sub_category_lv1 of group.sub_category_lv1) {
          sub_category_lv1.name1 = group.name + " /";
          flatedCategories.push(sub_category_lv1 as never);
          if (sub_category_lv1.sub_category_lv2) {
            for (const sub_category_lv2 of sub_category_lv1.sub_category_lv2) {
              sub_category_lv2.name1 = group.name + " /";
              sub_category_lv2.name2 = sub_category_lv1.name + " /";
              flatedCategories.push(sub_category_lv2 as never);
            }
          }
        }
      }
    });
    return flatedCategories;
  }

  resetJSON() {
    this.jsonPlaceHolder = this.jsonPlaceHolderCopy;
  }

  validateJSON() {
    let shortcuts: any;
    try {
      this.jsonPlaceHolder = JSON.stringify(this.records, null, 4);
      // Validation must retain record identity: correction controls edit these same review rows.
      shortcuts = this.records.filter((e) => e.checked);
    } catch (exception) {
      this.notification.toast("Invalid JSON format!");
      return;
    }

    if (!Array.isArray(shortcuts)) {
      this.notification.toast("JSON should be in array format!");
      return;
    }

    if (!shortcuts.length) {
      this.notification.toast("Please select at least one FlyCut!");
      return;
    }

    const data = {};
    const duplicates = [];
    for (const index in shortcuts) {
      if (shortcuts[index] && typeof shortcuts[index] === "object") {
        const shortcut = shortcuts[index];
        if (
          shortcut.shortcut &&
          shortcut.shortcut !== "" &&
          shortcut.title &&
          shortcut.title !== "" &&
          shortcut.html &&
          shortcut.html !== ""
        ) {
          if (!data[shortcut.shortcut]) {
            data[shortcut.shortcut] = [];
            shortcut.first_line = /[^\n]*/.exec(shortcut.html)[0].trim();
          }
          data[shortcut.shortcut].push(shortcut);
        } else {
          if (!shortcut.shortcut || shortcut.shortcut === "")
            this.notification.toast("FlyCut is missing required shortcut!");
          else if (!shortcut.title || shortcut.title === "")
            this.notification.toast("FlyCut " + shortcut.shortcut + " is missing required title!");
          else if (!shortcut.html || shortcut.html === "")
            this.notification.toast("FlyCut " + shortcut.shortcut + " is missing required message!");
          return;
        }
      } else {
        this.notification.toast("FlyCut is not in object format!");
        return;
      }
    }

    Object.keys(data).forEach((code) => {
      if (data[code].length > 1) duplicates.push(...data[code]);
    });
    if (duplicates.length) {
      this.duplicateImportRows = duplicates;
      return;
    } else {
      return shortcuts;
    }
  }

  importShortcuts() {
    if (this.importSubmitting) return;

    //case restriction error
    let planId = getPlanId();

    const selectedShortcutsHasErrors = find(this.records, function (o) {
      return o.checked && o.error && o.error != "";
    });
    if (selectedShortcutsHasErrors) {
      this.dialog.openDialogComponent(
        WarningDialogComponent,
        { self: this, type: "import", showTheStarter: planId === "Free" },
        "800px"
      );
      return;
    }

    // Freeze the submitted order before the request. Indexed backend errors refer to
    // this snapshot, never whichever position a row has after edit/delete/reorder.
    const submittedRows = this.records.filter((item) => item.checked).map((row) => ({
      id: this.importRowId(row),
      row,
      payload: this.toImportPayload(row),
    }));
    this.importSubmitting = true;
    this.importShortcutApi.import(submittedRows.map((item) => item.payload)).subscribe((result) => {
      this.importSubmitting = false;
      if (result.kind === "success") {
        this.finishImport();
        return;
      }
      this.handleImportFailure(result.failure, submittedRows);
    });
  }

  importJSON() {
    const jsonData = this.validateJSON();
    if (jsonData) {
      this.importShortcuts();
      // this.dialog.openDialogComponent(ImportShortcutsComponent, { shortcuts: jsonData, self: this }, "500px");
    }
  }

  retryDuplicateImport(): void {
    this.duplicateImportRows = [];
    this.importJSON();
  }

  get activeImportConflictRows(): any[] {
    return this.libraryConflictRows.length ? this.libraryConflictRows : this.duplicateImportRows;
  }

  dismissImportConflicts(): void {
    this.duplicateImportRows = [];
    this.libraryConflictRows = [];
  }

  skipDuplicate(shortcut: any): void {
    const index = this.records.indexOf(shortcut);
    if (index > -1) this.records.splice(index, 1);
    this.duplicateImportRows = this.duplicateImportRows.filter((row) => row !== shortcut);
    this.libraryConflictRows = this.libraryConflictRows.filter((row) => row !== shortcut);
  }

  previewDuplicate(shortcut: any): void {
    this.dialog.openDialogComponent(ImportPreviewDialogComponent, { shortcut }, "600px");
  }

  isEditingImportRow(shortcut: any): boolean {
    return this.editingImportRowIds.has(this.importRowId(shortcut));
  }

  editImportRow(shortcut: any): void {
    this.editingImportRowIds.add(this.importRowId(shortcut));
  }

  saveImportRow(shortcut: any): void {
    this.editingImportRowIds.delete(this.importRowId(shortcut));
  }

  retryLibraryImport(): void {
    this.libraryConflictRows = [];
    this.importJSON();
  }

  replaceLibraryConflicts(): void {
    if (this.importSubmitting || !this.libraryConflictRows.length) return;

    // Capture the exact targets before confirmation. A close/cancel does no write;
    // after confirmation later edits cannot silently replace a different FlyCut.
    const submittedRows = this.libraryConflictRows.map((row) => ({
      id: this.importRowId(row),
      row,
      payload: this.toImportPayload(row),
    }));
    this.dialog
      .confirm({
        title: "Are you sure you want to replace the existing FlyMSG?",
        message: "by doing this a new version of the message will be created overriding the current message.",
        confirmLabel: "Replace",
        cancelLabel: "Cancel",
        variant: "info",
        showClose: true,
      })
      .subscribe((confirmed) => {
        if (!confirmed || this.importSubmitting) return;
        this.importSubmitting = true;
        this.importShortcutApi.replace(submittedRows.map((item) => item.payload)).subscribe((result) => {
          this.importSubmitting = false;
          if (result.kind === "failure") {
            this.handleImportFailure(result.failure, submittedRows);
            return;
          }

          const succeededIds = new Set(result.outcomes.filter((outcome) => outcome.succeeded).map((outcome) => submittedRows[outcome.index].id));
          const failedOutcomes = result.outcomes.filter((outcome) => !outcome.succeeded);
          this.records = this.records.filter((row) => !succeededIds.has(this.importRowId(row)));
          this.libraryConflictRows = failedOutcomes
            .map((outcome) => ({ outcome, submitted: submittedRows[outcome.index] }))
            .filter(({ submitted }) => Boolean(submitted))
            .map(({ outcome, submitted }) => {
              const row = this.records.find((record) => this.importRowId(record) === submitted.id);
              if (row) row.error = outcome.errors[0] || "Replacement could not be completed. Please review and try again.";
              return row;
            })
            .filter(Boolean);
          if (succeededIds.size) this.extensionService.sendUpdateMessage();

          if (failedOutcomes.length) return;

          if (this.records.some((row) => row.checked)) this.importJSON();
          else this.finishImport(false);
        });
      });
  }

  private toImportPayload(row: any): ImportedFlyCut {
    return {
      shortcut: row.shortcut,
      title: row.title,
      html: row.html,
      text: this.shortcutService.getInlineStyledHTML(row.html.toString()),
      uploads: row.uploads ?? [],
      ...(row.category_id ? { category_id: row.category_id } : {}),
      ...(row.category ? { category: row.category } : {}),
    };
  }

  private importRowId(row: object): string {
    let id = this.importRowIds.get(row);
    if (!id) {
      id = `import-row-${this.nextImportRowId++}`;
      this.importRowIds.set(row, id);
    }
    return id;
  }

  private handleImportFailure(
    failure: ImportFailure,
    submittedRows: Array<{ id: string; row: any; payload: ImportedFlyCut }>
  ): void {
    if (failure.planLimited) {
      const planId = getPlanId();
      this.dialog.openDialogComponent(
        WarningDialogComponent,
        { self: this, type: "import", showTheStarter: planId === "Free" },
        "800px"
      );
      return;
    }

    const rowsById = new Map(this.records.map((row) => [this.importRowId(row), row]));
    const conflicts = failure.conflictIndexes
      .map((index) => submittedRows[index])
      .filter(Boolean)
      .map((submitted) => rowsById.get(submitted.id))
      .filter(Boolean);
    if (conflicts.length) {
      this.libraryConflictRows = conflicts;
      return;
    }

    const message = Object.values(failure.errors).flat()[0];
    this.notification.toast(
      message || (failure.network ? "We couldn't confirm your import. Your rows are still available to retry." : "Import failed."),
      "OK"
    );
  }

  private finishImport(refreshExtension = true): void {
    this.dialog.openDialogComponent(ImportDialogComponent, { self: this }, "400px");
    if (refreshExtension) this.extensionService.sendUpdateMessage();
    this.cancelImporting();
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    const file = event.dataTransfer?.files?.[0];
    if (file) this.processImportFile(file);
  }

  getHtml(shortcut) {
    if (shortcut?.html == null) return;
    return shortcut?.html.toString().split("\n")[0];
  }
  // Manage categories
  saveCategory(data: any) {
    this.dataService
      .post({
        url: "v1/user/shortcut-category",
        data,
        loaderName: CONTENT_VIEW_LOADER,
      })
      .subscribe((response: any) => {
        if (response && response.result) {
          this.getShortcutCategoryList(true);
          this.extensionService.sendUpdateMessage();
          this.notification.toast(`${data.category_id ? "Sub-Category" : "Category"} added successfully!`);
        }
      });
  }

  deleteShortcutCategory(data: any) {
    let category_type =
      data.category_id && typeof data.category_id === "string"
        ? "sub_categories_lv1"
        : data.sub_categories_lv1 && typeof data.sub_categories_lv1 === "string"
          ? "sub_categories_lv2"
          : "category";
    this.dataService
      .get({
        url: "v1/user/shortcut-category/dependency/" + data.id + "/remove?category_type=" + category_type,
      })
      .subscribe((response: any) => {
        if (response && response.result) {
          if (response && !response.result.has_dependency) {
            data.dependency = { type: "remove" };
            this.extensionService.sendUpdateMessage();
            this.dialog
              .confirm({
                title: "Do you want to <strong>delete</strong> this?",
                message: "Deleted items cannot be restored.",
                variant: "danger",
                confirmLabel: "Delete",
              })
              .subscribe((confirmed) => confirmed && this.delete(data));
          } else {
            this.dialog.openDialogComponent(CategoryDependencyComponent, {
              self: this,
              data,
            });
          }
        }
      });
  }

  tooltip(element: any): string {
    return `${element.name1 || element.name2 ? "Sub-" : ""}Category`;
  }

  shortcutCategoryRename(data: any) {
    const dialogRef = this.dialog.openDialogComponent(CategoryRenameComponent, {
      self: this,
      data,
      backdropClass: "dialog-category-backdrop",
    });
  }

  categoryUpdate(data: any) {
    let param: any;

    param = this.dataService.toSave(data, ["name"]);

    if (data.destination_category_id) {
      if (data.destination_category_type == "sub_categories_lv1") {
        param.sub_categories_lv1 = data.destination_category_id;
      } else if (data.destination_category_type == "category") {
        param.category_id = data.destination_category_id;
      }
    }

    if (data.hasOwnProperty("sub_category_lv1")) {
      //main-category
      param.source_category_type = "category";
    } else if (data.hasOwnProperty("sub_category_lv2")) {
      //lv1
      param.source_category_type = "sub_categories_lv1";
    } else {
      //lv2
      param.source_category_type = "sub_categories_lv2";
    }

    this.dataService
      .put({
        url: `v1/user/shortcut-category/${data.id}`,
        data: param,
        loaderName: CONTENT_VIEW_LOADER,
      })
      .subscribe((response: any) => {
        if (response && response.result) {
          this.getShortcutCategoryList(true);
          this.extensionService.sendUpdateMessage();
          this.notification.toast("Category updated successfully!");
        } else {
          this.notification.toast(
            "You cannot move a category to a level below another. A parent category can only be moved to the same level or a higher level.",
            "OK",
            7000
          );
        }
      });
  }

  delete(data: any) {
    if (data.hasOwnProperty("sub_category_lv1")) {
      //main-category
      data.dependency.category_type = "category";
    } else if (data.hasOwnProperty("sub_category_lv2")) {
      //lv1
      data.dependency.category_type = "sub_categories_lv1";
    } else {
      //lv2
      data.dependency.category_type = "sub_categories_lv2";
    }

    this.dataService
      .delete({
        url: "v1/user/shortcut-category/" + data.id,
        data: data.dependency,
        loaderName: CONTENT_VIEW_LOADER,
      })
      .subscribe((response: any) => {
        if (response && response.result) {
          this.getShortcutCategoryList(true);
          this.extensionService.sendUpdateMessage();
          this.notification.toast("Category deleted successfully!");
        }
      });
  }

  getShortcutCategoryList(reloadFromApi = false) {
    this.shortcutCategoryService.loadShortcutCategory({ reloadFromApi });
  }

  uploadListener($event: any): void {
    const file = $event?.target?.files?.[0] || $event?.srcElement?.files?.[0];
    if (file) this.processImportFile(file);
    if ($event?.target) $event.target.value = "";
  }

  private processImportFile(file: File): void {
    //show loading dialog
    const loadingDialog = this.dialog.openDialogComponent(LoadingDialogComponent, {}, "582px");
    if (!file || (!this.isValidCSVFile(file) && !this.isValidJSONFile(file))) {
      loadingDialog.close();
      this.notification.toast("Please choose a CSV or JSON file.");
      return;
    }
    let reader = new FileReader();
    //case text expander
    if (this.isValidCSVFile(file)) {
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        const ab: any = e.target.result;
        const wb: any = XLSX.read(ab);
        const wsname: string = wb.SheetNames[0];
        const ws: any = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        this.records = this.convertFromTextExpanderToVengresoFormat(data);
        this.jsonPlaceHolder = JSON.stringify(this.records, null, 4);
        this.isFlycutsImported = !!this.records.length;
        //hide loading dialog
        loadingDialog.close();
        try {
          this.checkImportedShortcutsRestriction();
        } catch (err) { }
      };
    }
    //case blaze
    if (this.isValidJSONFile(file)) {
      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        try {
          const parsed = JSON.parse(reader.result as string);
          const folders = Array.isArray(parsed?.folders) ? parsed.folders : [];
          const snippets = [];
          folders.forEach((folder) => {
            if (Array.isArray(folder?.snippets)) snippets.push(...folder.snippets);
          });

          this.records = this.convertFromBlazeToVengresoFormat(snippets);

          if (!this.records.length) {
            this.notification.toast("No snippets found in this file. Please check the file and try again.");
            return;
          }

          this.jsonPlaceHolder = JSON.stringify(this.records, null, 4);
          this.isFlycutsImported = !!this.records.length;
          this.checkImportedShortcutsRestriction();
        } catch (err) {
          this.notification.toast("Invalid file structure. The import file could not be processed.");
        } finally {
          loadingDialog.close();
        }
      };
    }
    //catch the errors
    reader.onerror = () => {
      loadingDialog.close();
      this.notification.toast("Could not read the file. Please try again.");
    };
  }

  checkImportedShortcutsRestriction() {
    this.importRestrictionError = false;
    const rewards = getRewards();

    this.records = this.records.map((item) => {
      const isValid = this.tinyMceConfigService.validateShortcutContent(
        item.html,
        item.text || item.html,
        this.currentFeatures,
        this.currentPlanId,
        rewards
      );

      if (!isValid) {
        this.importRestrictionError = true;
        const planLimit = this.currentPlanId === "Free" ? 2500 : 25000;
        item.error = `Exceeds ${planLimit} character limit. Reduce characters or upgrade plan.`;
      } else {
        item.error = "";
      }
      return item;
    });
  }

  convertFromTextExpanderToVengresoFormat(data: any) {
    let category: any = find(this.shortcutCategoryList, {
      name: "Imported FlyCuts",
    });
    if (!category) category = find(this.shortcutCategoryList, { name: "Default Category" });

    let result = [];
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      result.push({
        checked: true,
        title: row[2] ?? "",
        shortcut: row[0] ?? "",
        html: row[1].toString() ?? "",
        category_id: category?.id ? category.id : this.shortcutCategoryList[0].id,
        category: category?.name ? category.name : this.shortcutCategoryList[0].name,
      });
    }
    return result;
  }

  convertFromBlazeToVengresoFormat(data: any) {
    let category: any = find(this.shortcutCategoryList, {
      name: "Imported FlyCuts",
    });
    if (!category) category = find(this.shortcutCategoryList, { name: "Default Category" });

    const result = [];
    const items = Array.isArray(data) ? data : [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i] ?? {};
      result.push({
        checked: true,
        title: item.name ?? "",
        shortcut: item.shortcut ?? "",
        html: item.html != null ? item.html.toString() : "",
        text: item.text != null ? item.text.toString() : "",
        category_id: category?.id ? category.id : this.shortcutCategoryList[0]?.id,
        category: category?.name ? category.name : this.shortcutCategoryList[0]?.name,
      });
    }
    return result;
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  isValidJSONFile(file: any) {
    return file.name.endsWith(".json");
  }

  cancelImporting() {
    this.isFlycutsImported = false;
    this.records = [];
  }

  allImportedChecked = (): boolean => (this.records ?? []).filter((e) => !e.checked).length == 0;

  selectAll(event) {
    let check = this.allImportedChecked();
    this.records.forEach((item) => {
      item.checked = !check;
    });
    event.stopPropagation();
    event.preventDefault();
  }

  // `changeCategory()` (the only opener of ChangeShortcutCategoryComponent
  // here) and its `shortcutUpdate()` callback are gone with the "Change
  // Category" button on the Import FlyCuts rows — the picker had no effect on
  // the imported FlyCuts, so the control was removed from that screen.
  // ShortcutsComponent keeps its own copies, for real saved FlyCuts.

  deleteShortcut(data: any, index: number) {
    remove(this.records, function (n, i) {
      return index == i;
    });
    // this.dialog.openDialogComponent(
    //   ConfirmDialogComponent,
    //   { self: this, data },
    //   "330px"
    // );
  }

  // C3-5 (R14): vng-tabs' (selectedIndexChange) emits the plain number
  // directly (unlike Material's (selectedTabChange), which emitted the tab
  // object) — no more `event.index`. Precedent:
  // flymsg-cmc-fe/src/app/admin/extensions/extensions.component.ts:328-329
  // (`[selectedIndex]` + `(selectedIndexChange)="onTabChange($event)"`, the
  // handler assigning the field itself instead of a `[(selectedIndex)]`
  // two-way binding + a second explicit listener on the same output).
  handleNav(index: number) {
    this.activeTabIndex = index;
    let q = { queryParams: {} };
    switch (index) {
      case 0:
        q.queryParams["tab"] = "subscription";
        break;
      case 1:
        q.queryParams["tab"] = "statistics";
        break;
      case 2:
        q.queryParams["tab"] = "Profile";
        break;
      case 3:
        q.queryParams["tab"] = "manage";
        break;
      case 4:
        q.queryParams["tab"] = "Persona";
        break;
      case 5:
        q.queryParams["tab"] = "extension";
        break;
      case 6:
        q.queryParams["tab"] = "import";
        break;
      case 7:
        q.queryParams["tab"] = "teams";
        break;

      default:
        break;
    }
    this._router.navigate(["/settings"], q);
  }

  isFreemiumPlan = () => {
    return isFreemiumTier(this.currentPlan);
  };

  isStarterPlan = () => {
    return isStarterTier(this.currentPlan);
  };

  // Growth-or-higher on purpose: the previous inline list already included
  // the Teams plans and (via a `this.Lifetime` typo) meant to include
  // SalesPro — this page's growth CTAs apply to every plan above Starter.
  isGrowthPlan = () => {
    return isGrowthOrHigherTier(this.currentPlan);
  };

  isNotFreemiumPlan = () => {
    return this.currentPlan != null && !isFreemiumTier(this.currentPlan);
  };

  loadCtaScripts(tabParam: string) {
    const scriptElement = this.scriptService.loadJsScript(this.renderer, "https://js.hscta.net/cta/current.js");

    scriptElement.onload = () => {
      const config = { useNewLoader: "true", region: "na1" };

      switch (tabParam) {
        case SUBSCRIPTION_TAB:
          hbspt.cta.load(11964, CTA_UPGRADE_PLAN_ID, config);
          break;
        case SUBSCRIPTION_EDIT_STARTER:
          hbspt.cta.load(11964, CTA_EDIT_PLAN_ID, config);
          hbspt.cta.load(11964, CTA_COMPARE_PLAN_ID, config);
          break;
        case SUBSCRIPTION_EDIT_STARTER_PAUSED:
          hbspt.cta.load(11964, CTA_PAUSE_PLAN_ID, config);
          break;
        case SUBSCRIPTION_EDIT_STARTER_DOWNGRADE_FREEMIUM:
          hbspt.cta.load(11964, CTA_DOWNGRADE_TO_FREEMIUM_ID, config);
          break;
        case SUBSCRIPTION_EDIT_GROWTH:
          hbspt.cta.load(11964, CTA_EDIT_PLAN_GROWTH_ID, config);
          break;
        case SUBSCRIPTION_EDIT_GROWTH_PAUSED:
          // Pre-existing behavior: the paused-growth tab also loads the downgrade-to-freemium
          // CTA below. Preserved as-is (parity constraint); do not "fix" by adding a break
          // without confirming with product first.
          hbspt.cta.load(11964, CTA_GROWTH_PAUSE_PLAN_ID, config);
        // falls through
        case SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_FREEMIUM:
          hbspt.cta.load(11964, CTA_GROWTH_DOWNGRADE_TO_FREEMIUM_ID, config);
          break;
        case SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_STARTER:
          hbspt.cta.load(11964, CTA_GROWTH_DOWNGRADE_TO_STARTER_ID, config);
          break;
        default:
          break;
      }
    };

    scriptElement.onerror = () => { };
  }

  showDialog(tabParam: string): void {
    switch (tabParam) {
      case SUBSCRIPTION_EDIT_STARTER:
      case SUBSCRIPTION_EDIT_GROWTH:
        this.dialog.openDialogComponent(EditPlanComponent, {}, "600px");
        break;
      case SUBSCRIPTION_EDIT_STARTER_PAUSED:
      case SUBSCRIPTION_EDIT_GROWTH_PAUSED:
        this.dialog.openDialogComponent(PausedPlanComponent, {}, "500px");
        break;
      case SUBSCRIPTION_EDIT_STARTER_DOWNGRADE_FREEMIUM:
      case SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_FREEMIUM:
        this.dialog.openDialogComponent(
          DowngradedComponent,
          {
            planDowngradedTo: SubscriptionPlanType.Freemium,
          },
          "500px"
        );
        break;
      case SUBSCRIPTION_EDIT_GROWTH_DOWNGRADE_STARTER:
        this.dialog.openDialogComponent(
          DowngradedComponent,
          {
            planDowngradedTo: SubscriptionPlanType.Starter,
          },
          "500px"
        );
        break;
      default:
        break;
    }
  }

  changeTab(index: number, chartFilter: ChartFilterKey) {
    this.tabIndex = index;
    this.lineChartData = null;
    this.lineChartData = this.statisticsService.prepareChartData(this.statistics.chart_data, chartFilter);
    this.chart?.update();
  }

  getStatistic(
    differenceFromNow: number = null,
    dateType: DateType = "month",
    chartFilter: ChartFilterKey = "time_saved"
  ) {
    this.statisticsService.getStatistic(differenceFromNow, dateType).subscribe((response: any) => {
      if (response && response.result) {
        this.statistics = response.result;
        this.lineChartData = this.statisticsService.prepareChartData(this.statistics.chart_data, chartFilter);
        this.chart?.update();
      }
    });
  }

  filterStatistics(dateRangeId: number): void {
    const { differenceFromNow, dateType } = this.statisticsService.filterStatistics(dateRangeId);

    this.getStatistic(differenceFromNow, dateType, this.chartFilterKey);
  }

  editWordPerMinute(): void {
    this.editWPM = true;
  }

  editWagePerHour(): void {
    if (this.wphOverrideUser) return;

    this.editWPH = true;
  }

  chartHovered(event) { }

  chartClicked(event) { }

  saveWPM() {
    if (!this.wordsPerMinute || this.wordsPerMinute < 1) {
      this.notification.toast("Word per minute must be a valid number greater than 0");
      return;
    }

    this.dataService
      .put({
        url: "v1/user/setting",
        // vng-input's ControlValueAccessor emits strings — coerce so the API
        // keeps receiving a number.
        data: { words_per_minute: Number(this.wordsPerMinute) },
      })
      .subscribe({
        next: () => {
          this.getStatistic();
          this.editWPM = false;
          this.notification.toast("Word per minute updated");
        },
        error: () => { },
      });
  }

  saveWPH() {
    if (this.wphOverrideUser) return;

    if (!this.wagePerHour || this.wagePerHour < 1) {
      this.notification.toast("Wage per hour must be a valid number greater than 0");
      return;
    }

    this.dataService
      .put({
        url: "v1/user/setting",
        // vng-input's ControlValueAccessor emits strings — coerce so the API
        // keeps receiving a number.
        data: { wage_per_hour: Number(this.wagePerHour) },
      })
      .subscribe({
        next: () => {
          this.getStatistic();
          this.editWPH = false;
          this.notification.toast("Wage per hour updated");
        },
        error: () => { },
      });
  }

  // C3-5: handleChange('duration'|'general') used to flip panelOpen/
  // generalPanelOpen so a manual mat-icon chevron could mimic mat-select's
  // open/close affordance. vng-select renders its own trigger chevron
  // (vng-select.component.html) so the manual icons + this method are gone —
  // not replaced by an (openedChange) rebind because nothing else read those
  // two fields (verified grep, settings.component.* only).

  chartFilter(chartFilter: ChartFilterKey): void {
    this.lineChartData = null;
    this.lineChartData = this.statisticsService.prepareChartData(this.statistics.chart_data, chartFilter);
    this.chart?.update();
  }

  numberWithCommas(x: string | number) {
    if (!x) {
      return 0;
    }

    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  // CanComponentDeactivate interface
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.activeTabIndex === 5 && this.extensionSettings?.hasDirtySection()) {
      return false;
    }
    return true;
  }

  confirmLeave(): void {
    if (this.extensionSettings) {
      this.extensionSettings.discardAllDirty();
    }
  }
}
